// Mirrors backend/administraties.py; compare administratie values against these, never a literal.
export const ADMINISTRATIE_XEBIA_WORKPLACE = 'Xebia Workplace B.V.';
export const ADMINISTRATIE_XEBIA_BELGIUM = 'Xebia Belgium B.V.';
export const ADMINISTRATIE_XEBIA_NEDERLAND = 'Xebia Nederland B.V.';
export const ADMINISTRATIE_XEBIA_CLOUD_CONTROL = 'Xebia Cloud Control B.V.';
